import React from 'react'
import '../styles/Fallback.css'

class Offline extends React.Component {

    render(){
        return(
            <div className='Fallback'>
                <div className='Fallback-header'>
                    ChapChapGo
                </div>
                <br/> We can't connect to the internet at the moment
            </div>
        )
    }
}

export default Offline